import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Header from '../layout/Header';
import './LegalPages.css';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="legal-page-container">
      <Header user={null} />
      <Container className="legal-content-container">
        <div className="legal-header">
          <h1>個人情報保護方針</h1>
        </div>

        <Row>
          <Col lg={2} className="legal-ttl">PRIVACY POLICY</Col>
          <Col lg={10}>
            <div>
              <section className="legal-section">
                <h1>Ⅰ．基本方針</h1>
                <p>株式会社エグゼクティブサーチファーム（以下「当社」という）は、人材紹介、求人・採用活動の企画立案、人材教育、研修等に関するコンサルティング、イベントや講習会の開催、各種調査や情報サービスの提供を行っております。当社の事業において取り扱う個人情報の重要性を強く認識し、適正に取り扱うため、個人情報に関する法令等及び以下に定める個人情報保護方針を遵守することを宣言します。</p>
              </section>

              <section className="legal-section">
                <h2>1. 法令等の遵守について</h2>
                <p>個人情報を取り扱う上で、個人情報保護法をはじめとする法令や、関連ガイドライン等の国が定める指針、条例、その他の規範を確認し、遵守します。</p>
              </section>

              <section className="legal-section">
                <h2>2. 個人情報の取得・利用・提供について</h2>
                <p>個人情報の取得は適法かつ公正な手段によって行い、取得する個人情報の利用目的を特定し明らかにします。<br/>
                個人情報の利用は、利用目的の範囲内で、当サイトのサービス提供上必要な範囲内で行います。特定された利用目的の達成に必要な範囲を超えた個人情報の取り扱い（目的外利用）を行いません。また、目的外利用を行わないために、適切な管理措置を講じます。</p>
              </section>

              <section className="legal-section">
                <h2>3. 個人情報保護のための安全対策の実施について</h2>
                <p>個人情報を安全かつ適切に取り扱うことを確実にするため、個人情報の取扱責任者を特定し、取扱担当者については必要最小限の者に限定します。また、個人情報の滅失、破壊、改ざん、毀損、漏洩等の予防に努め、必要な安全管理策を実施します。</p>
              </section>

              <section className="legal-section">
                <h2>4. 個人情報の取り扱いに関する苦情及び相談</h2>
                <p>個人情報の取り扱いに関する苦情、相談等に対して、受付窓口として「個人情報相談窓口」を設置し、本人の意思の尊重のもと遅滞なく、速やかに対応を行います。</p>
              </section>

              <section className="legal-section">
                <h2>5. 個人情報保護マネジメントシステムの継続的改善</h2>
                <p>当社の経営環境、社会情勢の変化や情報技術の進歩等に対応した個人情報保護を実現するため、柔軟に「個人情報保護マネジメントシステム」を見直し、継続的な取組みのレベルアップ、改善に努めます。</p>
              </section>

              <div className="contact-info">
                <section className="legal-section">
                  <h2>個人情報に関するお問い合わせ窓口</h2>
                  <p>株式会社エグゼクティブサーチファーム　 個人情報相談窓口</p>
                  <p>〒153-0063 東京都目黒区目黒1-4-16目黒Gビル7F</p>
                  <p>メール　info@esf.co.jp</p>
                  <p>受付時間　10：00～18：00（土日祝日、年末年始の休業日を除く）</p>
                </section>
              </div>

              <br/>

              <section className="legal-section">
                <h1>Ⅱ．個人情報の利用目的について</h1>
                <p>当社が個人情報を利用する目的は、以下のとおりです。</p>
                <table className="legal-table">
                  <thead>
                    <tr>
                      <th>個人情報の類型</th>
                      <th>利用目的</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>サービス利用会員に関する個人情報</td>
                      <td>
                        <ul>
                          <li>会員の審査、認証のため</li>
                          <li>サービス提供のため</li>
                          <li>各種サービス、セミナー等の情報提供のため</li>
                          <li>ご相談、ご質問、ご連絡等の内容の把握、検討、調査および対応のため</li>
                          <li>利用状況を把握し､サービスの改善や新規サービスの開発に役立てるため</li>
                          <li>各種統計データを作成するため</li>
                        </ul>
                        <p>上記の目的に必要な範囲で、当社グループ、お取引先などに提供することがあります。</p>
                      </td>
                    </tr>
                    <tr>
                      <td>お取引先に関する個人情報</td>
                      <td>
                        <ul>
                          <li>お取引上の必要な諸連絡・商談等のため</li>
                          <li>取引情報管理、経理・財務処理のため</li>
                        </ul>
                        <p>上記の目的に必要な範囲で、当社グループ、お取引先などに提供することがあります。</p>
                      </td>
                    </tr>
                    <tr>
                      <td>お取引先から委託を受けた個人情報</td>
                      <td>
                        <ul>
                          <li>委託された業務の完遂のため</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>当社に関するお問い合せ・ご意見をいただいた皆様の個人情報</td>
                      <td>
                        <ul>
                          <li>寄せられたお問い合せ等への対応のため</li>
                          <li>サービスの紹介及びアンケートなどへの協力依頼のため</li>
                          <li>サービスの評価、改良及び新たなサービスの開発のため</li>
                          <li>広報、宣伝、マーケティング活動のため</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>イベントに参加された皆様に関する個人情報</td>
                      <td>
                        <ul>
                          <li>連絡、イベントの関連情報のご提供のため</li>
                          <li>関連商品またはサービスのご案内等のため</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>入社を希望される皆様に関する個人情報</td>
                      <td>
                        <ul>
                          <li>応募者への情報提供・連絡・通知のため</li>
                          <li>採用選考のため</li>
                          <li>事業内容その他の会社情報および応募要領等、就職活動に供する情報のご提供のため</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>従業員（退職者を含む。以下同じ）に関する個人情報</td>
                      <td>
                        <ul>
                          <li>人事、労務管理、給与、社会保険業務を行うため</li>
                          <li>採用、人材育成業務を行うため</li>
                          <li>その他当社の事業遂行に伴う業務、及び前号までの業務に付随する業務を行うため</li>
                        </ul>
                      </td>
                    </tr>
                  </tbody>
                </table>

              </section>

              <section className="legal-section">
                <h1>Ⅲ．安全管理措置に関する事項</h1>
                <p>当社は、その取り扱う個人データの漏えい、滅失又は毀損の防止その他個人データの安全管理のために、必要かつ適切な措置を講じます。当社が講じる安全管理措置については、「Ⅵ　お問合せ窓口」までお問い合わせください。</p>
              </section>

              <section className="legal-section">
                <h1>Ⅳ．個人データの「第三者提供」について</h1>
                <p>当社は、ご本人より取得させていただいた個人データを適切に管理し、あらかじめご本人の同意を得ることなく第三者に提供することはありません。ただし、次の場合は除きます。</p>
                  <ol className='parentheses-ul'>
                    <li>法令に基づく場合</li>
                    <li>人の生命、身体または財産の保護のために必要がある場合であって、本人の同意を得ることが困難であるとき。</li>
                    <li>公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難であるとき。</li>
                    <li>国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき。</li>
                  </ol>
              </section>

              <section className="legal-section">
                <h1>Ⅴ．利用者情報の外部送信について（アクセス解析について）</h1>
                <ol className='parentheses-ul'>
                  <li>利用目的</li>
                  <p>当社が運営するサイトの利用状況（アクセス回数、滞在時間等）を把握するため、以下のサービスを利用しています。</p>
                  <li>送信される利用者情報</li>
                    <ul>
                      <li>閲覧や行動履歴（閲覧した日時、閲覧ページURL、参照元URL、クリックやタップ操作等）</li>
                      <li>閲覧した機器の位置情報（IPアドレス、GPS情報等）</li>
                      <li>閲覧した人や機器を識別する情報（クッキー、デバイス識別子、ブラウザ識別子等）</li>
                    </ul>
                  <li>利用者情報取扱者</li>
                  <p>Googleアナリティクス（事業者　Google LLC）<br/>
                  プライバシーポリシー https://policies.google.com/privacy?hl=ja&gl=jp<br/>
                  オプトアウト https://tools.google.com/dlpage/gaoptout/<br/>
                  （Google Analyticsにより収集、記録、分析されたお客様の情報には、特定の個人を識別する情報は一切含まれません。）</p>
                </ol>
              </section>

              <section className="legal-section">
                <h1>Ⅵ．お問合せ窓口</h1>
                <p>ご意見、ご質問、苦情のお申出、保有個人データの開示・訂正、その他個人情報の取扱いに関するお問合せは、下記までご連絡をお願いいたします。</p>
                <p className='text-center'>記</p>
                <div className="contact-info">
                  <p>会社名：株式会社エグゼクティブサーチファーム</p>
                  <p>住所：〒153-0063 東京都目黒区目黒1-4-16目黒Gビル7F</p>
                  <p>メールアドレス：info@esf.co.jp</p>
                </div>
                <p className='text-end'>制定日：2025年2月17日<br/>
                株式会社エグゼクティブサーチファーム<br/>
                代表取締役　渡邉　洋樹</p>
              </section>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PrivacyPolicy;
